export default class DtnService {
    storeDtn = (job, data) => {
        return axios.post(`/jobs/${job}/dtn`, data); // Admin
    };

    storeProviderDtn = (provider, job, data) => {
        return axios.post(`/providers/${provider}/jobs/${job}/dtn`, data); // Provider
    };

    updateDtn = (job, data) => {
        if (data instanceof FormData) {
            data.append('_method', 'PATCH');
            return axios.post(`/jobs/${job}/dtn/update`, data); // Admin
        }
        return axios.patch(`/jobs/${job}/dtn/update`, data);
    };

    updateProviderDtn = (provider, job, data) => {
        if (data instanceof FormData) {
            data.append('_method', 'PATCH');
            return axios.post(`/providers/${provider}/jobs/${job}/dtn/update`, data); // Provider
        }
        return axios.patch(`/providers/${provider}/jobs/${job}/dtn/update`, data);
    };

    updateJobStatus = (job, data) => {
        return axios.post(`/jobs/${job}/status`, data); // Admin
    };

    requiresDtnReason(jobId) {
        return axios.get(`/jobs/${jobId}/requires-dtn-reason`);
    }

    requiresSuperadminReview(jobId) {
    return axios.get(`/jobs/${jobId}/has-pending-superadmin`);
}
}
